import { combineReducers } from 'redux'
import yodlee from './api/yodlee/reducer'
import user from './api/user/reducer'

const reducers = combineReducers({
  yodlee,
  user,
})

export default reducers



// WEBPACK FOOTER //
// ./reducers.js